var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2285 18.229L22.916 22.9165",
    stroke: "#B9B9B9",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.833 11.458C20.833 6.28034 16.6357 2.08301 11.458 2.08301C6.28034 2.08301 2.08301 6.28034 2.08301 11.458C2.08301 16.6357 6.28034 20.833 11.458 20.833C16.6357 20.833 20.833 16.6357 20.833 11.458Z",
    stroke: "#B9B9B9",
    strokeWidth: 1.5625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearch);
export default __webpack_public_path__ + "static/media/newSearch.2e266044ef402ae9ab949fda961eeb09.svg";
export { ForwardRef as ReactComponent };